<template>
  <div class="alipay-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i> 首页
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <i class="el-icon-user"></i> {{ isEdit ? '编辑员工' : '新增员工' }}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 卡片内容 -->
    <el-card class="alipay-card" shadow="never">
      <el-form
        :model="addForm"
        :rules="rules"
        ref="formForRef"
        label-width="110px"
        label-position="right"
        size="small"
      >
        <!-- 基本信息区域 -->
        <div class="form-section">
          <div class="section-title">
            <i class="el-icon-info"></i>
            <span>基本信息</span>
          </div>

          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="所属部门" prop="department_id">
                <el-cascader
                  v-model="addForm.department_id"
                  :props="departmentProps"
                  :options="departmentData"
                  placeholder="请选择部门"
                  clearable
                  style="width: 100%;"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="员工姓名" prop="name_cn">
                <el-input 
                  v-model="addForm.name_cn" 
                  placeholder="请输入员工姓名"
                  prefix-icon="el-icon-user"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系电话" prop="mobile">
                <el-input 
                  v-model="addForm.mobile" 
                  placeholder="请输入联系电话"
                  prefix-icon="el-icon-phone"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="性别" prop="sex">
                <el-select v-model="addForm.sex" placeholder="请选择性别" style="width: 100%;">
                  <el-option label="男" value="1">
                    <span style="color: #00b578;">● 男</span>
                  </el-option>
                  <el-option label="女" value="0">
                    <span style="color: #e6a23c;">● 女</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="身份证号" prop="id_code">
                <el-input 
                  v-model="addForm.id_code" 
                  placeholder="请输入身份证号"
                  prefix-icon="el-icon-document"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="工作状态" prop="work_status">
                <el-select v-model="addForm.work_status" placeholder="请选择工作状态" style="width: 100%;">
                  <el-option label="在岗" value="1">
                    <span style="color: #00b578;">● 在岗</span>
                  </el-option>
                  <el-option label="离岗" value="0">
                    <span style="color: #e6a23c;">● 离岗</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="是否在建" prop="status">
                <el-select v-model="addForm.status" placeholder="请选择是否在建" style="width: 100%;">
                  <el-option label="是" value="1">
                    <span style="color: #00b578;">● 是</span>
                  </el-option>
                  <el-option label="否" value="0">
                    <span style="color: #909399;">● 否</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- 社保信息区域 -->
        <div class="form-section">
          <div class="section-title">
            <i class="el-icon-office-building"></i>
            <span>社保信息</span>
          </div>

          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="费用缴纳单位" prop="insurance_unit_name">
                <el-input 
                  v-model="addForm.insurance_unit_name" 
                  placeholder="请输入费用缴纳单位"
                  prefix-icon="el-icon-office-building"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="社保状况" prop="insurance_status">
                <el-input 
                  v-model="addForm.insurance_status" 
                  placeholder="请输入社保状况"
                  prefix-icon="el-icon-medal"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="社保缴纳时间" prop="insurance_start_time">
                <el-date-picker 
                  v-model="addForm.insurance_start_time" 
                  type="date" 
                  placeholder="选择缴纳时间"
                  value-format="yyyy-MM-dd"
                  prefix-icon="el-icon-date"
                  clearable
                  style="width: 100%;"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- 执业信息区域 -->
        <div class="form-section">
          <div class="section-title">
            <i class="el-icon-s-flag"></i>
            <span>执业信息</span>
          </div>

          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="执业时间" prop="work_start_time">
                <el-input 
                  v-model="addForm.work_start_time" 
                  placeholder="请输入执业时间"
                  prefix-icon="el-icon-time"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- 底部按钮 -->
        <div class="form-actions">
          <el-button type="primary" @click="submitForm" icon="el-icon-check" size="medium">保存</el-button>
          <el-button @click="goBack" icon="el-icon-back" size="medium">返回</el-button>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
// import axios from 'axios'
// import moment from 'moment'

export default {
  name: 'proxyEmployeeForm',
  data() {
    return {
      // 部门数据
      departmentData: [],
      departmentProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        checkStrictly: true,
        emitPath: false
      },
      
      // 表单数据
      addForm: {
        department_id: '',
        work_start_time: "",
        work_status: '1',
        status: '',
        name_cn: '',
        insurance_unit_name: '',
        insurance_start_time: '',
        insurance_status: '',
        id: '',
        sex: '1',
        id_code: '',
        mobile: '',
        access_token: sessionStorage.getItem('token'),
        company_id: sessionStorage.getItem('company_id'),
        proxy_id: sessionStorage.getItem('proxy_id'),
      },
      
      // 验证规则
      rules: {
        name_cn: [
          { required: true, message: "请输入员工姓名", trigger: 'blur' },
          { min: 2, max: 20, message: "长度在 2 到 20 个字符", trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: "请输入联系电话", trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: "请输入正确的手机号码", trigger: 'blur' }
        ],
        department_id: [
          { required: true, message: "请选择所属部门", trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    isEdit() {
      return this.addForm.id && this.addForm.id > 0
    }
  },
  mounted() {
    const id = this.$route.query.id
    if (id && !isNaN(id) && id > 0) {
      this.addForm.id = id
      this.getOne()
    }
    this.DepartmentList()
  },
  methods: {
    // 获取部门列表
    DepartmentList() {
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        proxy_id: sessionStorage.getItem('proxy_id'),
      }
      this.$axios.proxyDepartmentTree(param).then(res => {
        if (res.code == 200) {
          this.departmentData = res.data || []
        }
      }).catch(error => {
        console.log(error)
      })
    },
    
    // 获取员工详情
    getOne() {
      const param = {
        access_token: this.addForm.access_token,
        company_id: this.addForm.company_id,
        id: this.addForm.id
      }
      this.$axios.proxyEmployeeOne(param).then((res) => {
        if (res.code == 200) {
          const item = res.data
          this.addForm.name_cn = item.name_cn
          this.addForm.sex = item.sex ? item.sex + '' : '1'
          this.addForm.department_id = item.department_id
          this.addForm.id_code = item.id_code
          this.addForm.mobile = item.mobile
          this.addForm.status = item.status ? item.status + '' : ''
          this.addForm.work_status = item.work_status ? item.work_status + '' : '1'
          this.addForm.insurance_unit_name = item.insurance_unit_name
          this.addForm.insurance_status = item.insurance_status
          this.addForm.insurance_start_time = item.insurance_start_time
          this.addForm.work_start_time = item.work_start_time
        }
      }).catch(error => {
        console.error('获取员工详情失败:', error)
        this.$message.error('获取员工详情失败')
      })
    },
    
    // 提交表单
    submitForm() {
      this.$refs.formForRef.validate((valid) => {
        if (valid) {
          const params = { ...this.addForm }
          
          this.$axios.proxyEmployeeSave(params).then(res => {
            if (res.code == 200) {
              this.$message.success("保存成功")
              setTimeout(() => {
                this.$router.push('/proxyEmployeeList')
              }, 1500)
            } else {
              this.$message.error(res.msg || "保存失败")
            }
          }).catch(error => {
            console.log(error)
            this.$message.error("保存失败")
          })
        }
      })
    },
    
    // 返回列表
    goBack() {
      this.$router.push('/proxyEmployeeList')
    }
  }
}
</script>

<style lang="scss" scoped>
.alipay-container {
  padding: 16px 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

// 面包屑样式
.breadcrumb-wrapper {
  margin-bottom: 16px;
  
  .el-breadcrumb {
    font-size: 14px;
    
    i {
      margin-right: 4px;
    }
  }
}

// 卡片样式
.alipay-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.08);
  }
}

.alipay-card .el-card__body {
  padding: 20px 24px;
}

// 表单区块样式
.form-section {
  margin-bottom: 28px;
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 20px;
  
  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }
  
  .section-title {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 20px;
    padding-left: 8px;
    border-left: 3px solid #1677ff;
    
    i {
      font-size: 16px;
      color: #1677ff;
    }
    
    span {
      font-size: 15px;
      font-weight: 600;
      color: #1f2d3d;
    }
  }
}

// 表单项样式
.el-form-item {
  margin-bottom: 20px;
}

.el-form-item .el-form-item__label {
  font-weight: 500;
  color: #1f2d3d;
}

.el-input .el-input__inner,
.el-select .el-input__inner,
.el-cascader .el-input__inner {
  border-radius: 8px;
  border-color: #e4e7ed;
  transition: all 0.2s;
}

.el-input .el-input__inner:focus,
.el-select .el-input__inner:focus,
.el-cascader .el-input__inner:focus {
  border-color: #1677ff;
  box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.1);
}

// 底部按钮样式
.form-actions {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 32px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
  
  .el-button {
    border-radius: 24px;
    padding: 10px 28px;
  }
  
  .el-button--primary {
    background: #1677ff;
    border-color: #1677ff;
    
    &:hover {
      background: #4096ff;
      border-color: #4096ff;
    }
  }
}
</style>